<!--
	Рисунок к шагу установки.

	Рисунки собственные: показаны элементы интерфейса, о которых идёт речь в
	шаге, но нарисованы простыми фигурами, а не заимствованы откуда-либо. Чужие
	снимки экрана устарели бы с ближайшим обновлением браузера, а фигуры — нет.

	Каждый рисунок зовётся по имени, а не по номеру шага. Раньше было по
	номеру, и стоило переписать тексты — картинки молча разъехались: под шагом
	«На экран „Домой“» оказалось «Показать больше».

	Цвета берутся из токенов, поэтому рисунки живут вместе с темой и одинаково
	читаются в тёмной и светлой.
-->
<script lang="ts" module>
	export type ArtName =
		| 'ios-share'
		| 'ios-share-top'
		| 'ios-sheet'
		| 'ios-add-row'
		| 'ios-confirm'
		| 'home-icon'
		| 'android-menu'
		| 'android-install-row'
		| 'samsung-bar'
		| 'samsung-add-page'
		| 'firefox-menu'
		| 'desktop-omnibox'
		| 'desktop-menu'
		| 'desktop-window'
		| 'mac-menubar'
		| 'mac-add-dock'
		| 'mac-dock';
</script>

<script lang="ts">
	interface Props {
		art: ArtName;
	}

	let { art }: Props = $props();
</script>

{#snippet phone()}
	<rect class="screen" x="60" y="18" width="200" height="200" rx="26" />
{/snippet}

{#snippet window()}
	<rect class="screen" x="26" y="30" width="268" height="150" rx="14" />
	<line class="divider" x1="26" y1="62" x2="294" y2="62" />
	<circle class="muted-circle" cx="44" cy="46" r="4" />
	<circle class="muted-circle" cx="58" cy="46" r="4" />
	<circle class="muted-circle" cx="72" cy="46" r="4" />
{/snippet}

{#snippet appIcon(x: number, y: number, size: number)}
	<rect class="app-icon" {x} {y} width={size} height={size} rx={size * 0.25} />
	<g class="app-letter" style:stroke-width={size * 0.1}>
		<path
			d="M{x + size * 0.28} {y + size * 0.75} L{x + size * 0.5} {y + size * 0.28} L{x +
				size * 0.72} {y + size * 0.75}"
		/>
		<path d="M{x + size * 0.37} {y + size * 0.6} H{x + size * 0.63}" />
	</g>
{/snippet}

<div class="frame" aria-hidden="true">
	<svg viewBox="0 0 320 200" role="presentation" data-art={art}>
		<defs>
			<clipPath id="clip-{art}">
				<rect x="60" y="18" width="200" height="200" rx="26" />
			</clipPath>
		</defs>

		{#if art === 'ios-share'}
			<!-- Нижняя панель Safari, выделена кнопка «Поделиться» -->
			{@render phone()}
			<rect class="bar" x="76" y="140" width="120" height="34" rx="17" />
			<rect class="hint" x="94" y="152" width="72" height="10" rx="5" />
			<circle class="target" cx="224" cy="157" r="18" />
			<g class="share-glyph">
				<rect x="217" y="155" width="14" height="12" rx="2.5" />
				<path d="M224 148v10M220 152l4-4 4 4" />
			</g>
			<path class="arrow" d="M190 70c34 8 46 32 44 60" />
			<path class="arrow-head" d="M227 122l7 14 8-13" />
		{:else if art === 'ios-share-top'}
			<!-- Панель другого браузера: кнопка «Поделиться» рядом с адресом -->
			{@render phone()}
			<rect class="bar" x="76" y="40" width="168" height="30" rx="15" />
			<rect class="hint" x="92" y="50" width="86" height="10" rx="5" />
			<circle class="target" cx="222" cy="55" r="14" />
			<g class="share-glyph">
				<rect x="216" y="54" width="12" height="10" rx="2" />
				<path d="M222 48v9M219 51l3-3 3 3" />
			</g>
			<path class="arrow" d="M150 110c30-8 56-18 68-38" />
			<path class="arrow-head" d="M212 76l8-4 1 9" />
		{:else if art === 'ios-sheet'}
			<!-- Лист «Поделиться» со списком действий -->
			{@render phone()}
			<g clip-path="url(#clip-{art})">
				<rect class="sheet" x="66" y="60" width="188" height="164" rx="22" />
				<rect class="hint" x="146" y="70" width="28" height="5" rx="2.5" />
				<circle class="muted-circle" cx="98" cy="106" r="18" />
				<circle class="muted-circle" cx="146" cy="106" r="18" />
				<circle class="muted-circle" cx="194" cy="106" r="18" />
				<rect class="row-active" x="76" y="140" width="168" height="34" rx="12" />
				<rect class="hint strong" x="90" y="152" width="120" height="10" rx="5" />
				<rect class="hint" x="90" y="188" width="140" height="9" rx="4.5" />
			</g>
		{:else if art === 'ios-add-row'}
			<!-- Пункт «На экран „Домой“» со знаком «плюс» -->
			{@render phone()}
			<g clip-path="url(#clip-{art})">
				<rect class="sheet" x="66" y="80" width="188" height="144" rx="22" />
				<rect class="row-active" x="76" y="106" width="168" height="40" rx="12" />
				<rect class="plus-box" x="88" y="117" width="18" height="18" rx="5" />
				<path class="plus" d="M97 121v10M92 126h10" />
				<rect class="hint strong" x="116" y="121" width="112" height="10" rx="5" />
				<rect class="hint" x="88" y="164" width="140" height="9" rx="4.5" />
			</g>
		{:else if art === 'ios-confirm'}
			<!-- Окошко подтверждения: имя значка и кнопка «Добавить» -->
			{@render phone()}
			<g clip-path="url(#clip-{art})">
				<rect class="sheet" x="80" y="60" width="160" height="120" rx="18" />
				{@render appIcon(96, 76, 32)}
				<rect class="field" x="138" y="82" width="86" height="20" rx="10" />
				<line class="divider" x1="80" y1="128" x2="240" y2="128" />
				<rect class="cta" x="164" y="140" width="60" height="24" rx="12" />
				<rect class="hint" x="96" y="148" width="42" height="8" rx="4" />
			</g>
		{:else if art === 'home-icon'}
			<!-- Значок приложения среди остальных -->
			{@render phone()}
			<circle class="muted-circle" cx="98" cy="86" r="18" />
			<circle class="muted-circle" cx="222" cy="86" r="18" />
			{@render appIcon(132, 58, 56)}
			<rect class="hint accent-hint" x="136" y="126" width="48" height="8" rx="4" />
			<circle class="muted-circle" cx="98" cy="164" r="18" />
			<circle class="muted-circle" cx="160" cy="164" r="18" />
			<circle class="muted-circle" cx="222" cy="164" r="18" />
		{:else if art === 'android-menu'}
			<!-- Три точки справа сверху -->
			{@render phone()}
			<rect class="bar" x="76" y="40" width="140" height="30" rx="15" />
			<rect class="hint" x="92" y="50" width="86" height="10" rx="5" />
			<circle class="target" cx="234" cy="55" r="16" />
			<g class="dots">
				<circle cx="234" cy="48" r="2.4" />
				<circle cx="234" cy="55" r="2.4" />
				<circle cx="234" cy="62" r="2.4" />
			</g>
			<path class="arrow" d="M160 118c40-6 66-24 72-44" />
			<path class="arrow-head" d="M225 76l8-4 1 9" />
		{:else if art === 'android-install-row'}
			<!-- Список меню с выделенным пунктом установки -->
			{@render phone()}
			<g clip-path="url(#clip-{art})">
				<rect class="sheet" x="140" y="40" width="114" height="150" rx="14" />
				<rect class="hint" x="154" y="58" width="80" height="8" rx="4" />
				<rect class="row-active" x="146" y="78" width="102" height="30" rx="10" />
				<rect class="plus-box" x="154" y="86" width="14" height="14" rx="4" />
				<path class="plus" d="M161 89v8M157 93h8" />
				<rect class="hint strong" x="176" y="88" width="62" height="9" rx="4.5" />
				<rect class="hint" x="154" y="122" width="80" height="8" rx="4" />
				<rect class="hint" x="154" y="142" width="66" height="8" rx="4" />
			</g>
		{:else if art === 'samsung-bar'}
			<!-- Нижняя панель с кнопкой из трёх полос -->
			{@render phone()}
			<rect class="bar" x="76" y="152" width="168" height="36" rx="14" />
			<circle class="muted-circle" cx="102" cy="170" r="9" />
			<circle class="muted-circle" cx="140" cy="170" r="9" />
			<circle class="muted-circle" cx="178" cy="170" r="9" />
			<circle class="target" cx="220" cy="170" r="15" />
			<g class="lines">
				<path d="M212 165h16M212 170h16M212 175h16" />
			</g>
			<path class="arrow" d="M188 96c30 18 38 40 34 56" />
			<path class="arrow-head" d="M215 148l7 12 8-11" />
		{:else if art === 'samsung-add-page'}
			<!-- Пункт «Добавить страницу» → «На главный экран» -->
			{@render phone()}
			<g clip-path="url(#clip-{art})">
				<rect class="sheet" x="66" y="96" width="188" height="128" rx="18" />
				<rect class="hint" x="82" y="112" width="90" height="8" rx="4" />
				<rect class="row-active" x="76" y="132" width="168" height="34" rx="12" />
				<rect class="plus-box" x="88" y="141" width="16" height="16" rx="4" />
				<path class="plus" d="M96 144v10M91 149h10" />
				<rect class="hint strong" x="114" y="144" width="110" height="9" rx="4.5" />
				<rect class="hint" x="88" y="182" width="120" height="8" rx="4" />
			</g>
		{:else if art === 'firefox-menu'}
			<!-- Меню Firefox: три точки справа в нижней панели -->
			{@render phone()}
			<rect class="bar" x="76" y="150" width="132" height="34" rx="17" />
			<rect class="hint" x="94" y="162" width="80" height="10" rx="5" />
			<circle class="target" cx="228" cy="167" r="16" />
			<g class="dots">
				<circle cx="228" cy="160" r="2.4" />
				<circle cx="228" cy="167" r="2.4" />
				<circle cx="228" cy="174" r="2.4" />
			</g>
			<path class="arrow" d="M196 92c30 20 38 42 34 58" />
			<path class="arrow-head" d="M223 144l7 12 8-11" />
		{:else if art === 'desktop-omnibox'}
			<!-- Окно браузера: значок установки справа в адресной строке -->
			{@render window()}
			<rect class="bar" x="92" y="34" width="176" height="24" rx="12" />
			<rect class="hint" x="106" y="42" width="96" height="8" rx="4" />
			<circle class="target" cx="252" cy="46" r="13" />
			<g class="plus-on-accent">
				<path d="M252 41v10M247 46h10" />
			</g>
			<path class="arrow" d="M188 120c40-6 62-24 66-52" />
			<path class="arrow-head" d="M247 66l8-4 1 9" />
		{:else if art === 'desktop-menu'}
			<!-- Меню браузера с пунктом установки -->
			{@render window()}
			<rect class="sheet" x="168" y="66" width="118" height="104" rx="12" />
			<rect class="hint" x="182" y="82" width="82" height="8" rx="4" />
			<rect class="row-active" x="174" y="100" width="106" height="28" rx="10" />
			<rect class="plus-box" x="182" y="107" width="14" height="14" rx="4" />
			<path class="plus" d="M189 110v8M185 114h8" />
			<rect class="hint strong" x="204" y="109" width="66" height="9" rx="4.5" />
			<rect class="hint" x="182" y="142" width="76" height="8" rx="4" />
		{:else if art === 'desktop-window'}
			<!-- Приложение открылось своим окном, без адресной строки -->
			{@render window()}
			{@render appIcon(44, 76, 40)}
			<rect class="hint strong" x="96" y="82" width="120" height="10" rx="5" />
			<rect class="hint" x="96" y="102" width="86" height="8" rx="4" />
			<rect class="cta" x="44" y="132" width="88" height="24" rx="12" />
		{:else if art === 'mac-menubar'}
			<!-- Строка меню Mac с выделенным «Файл» -->
			{@render window()}
			<rect class="menubar" x="26" y="30" width="268" height="26" rx="14" />
			{@render appIcon(38, 36, 14)}
			<rect class="row-active" x="62" y="34" width="42" height="18" rx="6" />
			<rect class="hint strong" x="70" y="40" width="26" height="7" rx="3.5" />
			<rect class="hint" x="116" y="40" width="34" height="7" rx="3.5" />
			<rect class="hint" x="162" y="40" width="30" height="7" rx="3.5" />
			<path class="arrow" d="M112 132c-16-28-18-52-16-64" />
			<path class="arrow-head" d="M91 74l5-8 6 7" />
		{:else if art === 'mac-add-dock'}
			<!-- Выпадающее меню с пунктом «Добавить в Dock» -->
			{@render window()}
			<rect class="menubar" x="26" y="30" width="268" height="26" rx="14" />
			<rect class="row-active" x="62" y="34" width="42" height="18" rx="6" />
			<rect class="hint strong" x="70" y="40" width="26" height="7" rx="3.5" />
			<rect class="sheet" x="62" y="60" width="132" height="106" rx="12" />
			<rect class="hint" x="74" y="74" width="86" height="8" rx="4" />
			<rect class="row-active" x="68" y="92" width="120" height="28" rx="10" />
			<rect class="plus-box" x="76" y="99" width="14" height="14" rx="4" />
			<path class="plus" d="M83 102v8M79 106h8" />
			<rect class="hint strong" x="98" y="101" width="80" height="9" rx="4.5" />
			<rect class="hint" x="74" y="136" width="72" height="8" rx="4" />
		{:else}
			<!-- Dock со значком приложения -->
			<rect class="screen" x="26" y="24" width="268" height="116" rx="14" />
			<rect class="hint" x="120" y="70" width="80" height="10" rx="5" />
			<rect class="dock" x="70" y="152" width="180" height="34" rx="14" />
			<circle class="muted-circle" cx="94" cy="169" r="11" />
			<circle class="muted-circle" cx="124" cy="169" r="11" />
			{@render appIcon(144, 155, 28)}
			<circle class="muted-circle" cx="196" cy="169" r="11" />
			<circle class="muted-circle" cx="226" cy="169" r="11" />
		{/if}
	</svg>
</div>

<style>
	.frame {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		border-radius: var(--radius-l);
		/* Подложка карточки — приглушённый акцент: рисунки читаются
		   и в тёмной, и в светлой теме. */
		background: linear-gradient(150deg, var(--accent-muted), var(--background-secondary));
		overflow: hidden;
	}

	svg {
		width: 100%;
		max-width: 320px;
		height: auto;
	}

	.screen {
		fill: var(--background-primary);
		stroke: var(--border-strong);
		stroke-width: 2;
	}

	.bar,
	.sheet,
	.menubar,
	.dock {
		fill: var(--background-secondary);
	}

	.hint {
		fill: var(--text-disabled);
	}

	.hint.strong {
		fill: var(--text-secondary);
	}

	.hint.accent-hint {
		fill: var(--accent-primary);
	}

	.muted-circle {
		fill: var(--background-tertiary);
	}

	/* Целевой элемент шага подсвечен акцентом — на него и нужно нажать. */
	.target {
		fill: var(--accent-primary);
	}

	.dots {
		fill: var(--text-on-accent);
	}

	.share-glyph {
		fill: none;
		stroke: var(--text-on-accent);
		stroke-width: 2;
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	.lines,
	.plus-on-accent {
		fill: none;
		stroke: var(--text-on-accent);
		stroke-width: 2.4;
		stroke-linecap: round;
	}

	.plus {
		stroke: var(--accent-primary);
		stroke-width: 2.4;
		fill: none;
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	.plus-box {
		fill: none;
		stroke: var(--accent-primary);
		stroke-width: 2;
	}

	.row-active {
		fill: var(--background-tertiary);
	}

	.arrow {
		fill: none;
		stroke: var(--text-primary);
		stroke-width: 3;
		stroke-linecap: round;
	}

	.arrow-head {
		fill: none;
		stroke: var(--text-primary);
		stroke-width: 3;
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	.app-icon {
		fill: var(--accent-primary);
	}

	.app-letter {
		fill: none;
		stroke: var(--text-on-accent);
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	.field {
		fill: var(--background-secondary);
	}

	.cta {
		fill: var(--accent-primary);
	}

	.divider {
		stroke: var(--border-subtle);
		stroke-width: 1.5;
	}
</style>
